import { BaseRule } from '../BaseRule';

class RequiredRule extends BaseRule {
	required = true;
	allowEmptyStrings: boolean;

	constructor(errorMessage = 'Обязательное поле', allowEmptyStrings = false) {
		super('required', errorMessage);
		if (!errorMessage) {
			this.errorMessage = 'Обязательное поле';
		}
		this.allowEmptyStrings = allowEmptyStrings;
	}

	isValidInternal = (val: string) => {
		let testVal;
		const required = this.required;
		if (val === undefined || val === null) {
			return !required;
		}

		testVal = val;
		if (typeof val === 'string') {
			if (this.allowEmptyStrings) {
				return true;
			}
			testVal = val.trim();
		}

		if (!required) {
			// if they passed: { required: false }, then don't require this
			return true;
		}

		return testVal.length > 0;
	};
}

export default RequiredRule;
